import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { BehaviorSubject, Subject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DashboardService {
  
  private dataSource = new BehaviorSubject(null);
  sharedCount = this.dataSource.asObservable();
  invokeEvent: Subject<any> = new Subject(); 
  private bgColor = new BehaviorSubject(null);
  appendBgClr = this.bgColor.asObservable();
  private subject = new Subject<any>();
  updateHeaderCounts: Subject<any> = new Subject(); 
  constructor(
    private _http: HttpClient
  ) { }

  setBgColor(obj : any){
    this.bgColor.next(obj);
  }

  refreshCount(data: any[]) {
    this.dataSource.next(data);
  }

  getSubmittedForms(organizationId, page?, pageSize?, filters?) {
    let endPoint = `${environment.url}/getSubmittedForms/${organizationId}?page=${page}&limit=${pageSize}`
    // return this._http.get(environment.url + "/getSubmittedForms/" + organizationId);
    return this._http.get(endPoint, { params: filters })
  }

  getSubmittedFormsOfActionType(organizationId, actionType, isHelpAdmin?) {
    let endpoint = ""
    if(isHelpAdmin) {
      endpoint = `${environment.url}/forms/${organizationId}/${actionType}?isHelpAdmin=true`
    } else {
      endpoint = `${environment.url}/forms/${organizationId}/${actionType}`
    }
    return this._http.get(endpoint);
  }

  deleteSubmittedForm(requestData) {
    return this._http.put(environment.url +  "/deleteForm", requestData, { headers: { "hideLoader": "true" }});
  }

  archiveSubmittedForm(requestData) {
    return this._http.put(environment.url +  "/archiveForm", requestData, { headers: { "hideLoader": "true" }});
  }

  flagSubmittedForm(requestData) {
    return this._http.put(environment.url +  "/form/flag", requestData, { headers: { "hideLoader": "true" }});
  }

  unflagSubmittedForm(requestData) {
    return this._http.put(environment.url +  "/form/unflag", requestData, { headers: { "hideLoader": "true" }});
  }

  sendBulkSms(requestData) {
    return this._http.post(environment.url + "/forms/sendSMS", requestData);
  }

  sendBulkEmail(requestData) {
    return this._http.post(environment.url + "/forms/sendEmail", requestData);
  }

  sendBulkPdf(requestData) {
    return this._http.post(environment.url + "/forms/pdf", requestData);
  }

  getArchivedForms(actionTypeId) {
    return this._http.get(environment.url + "/archivedForms/" + actionTypeId);
  }
  
  restoreArchivedForms(requestData) {
    return this._http.put(environment.url + "/forms/restoreArchived", requestData);
  }

  deleteActionTypeForms(requestData) {
    return this._http.put(environment.url +  "/actionTypes/forms/delete", requestData);
  }

  archiveActionTypeForms(requestData) {
    return this._http.put(environment.url + "/actionTypes/forms/archive", requestData);
  }

  reorderActionType(requestData) {
    return this._http.put(environment.url + "/actionTypes/forms/updateOrder", requestData);
  }

  deleteFormInActionType(requestData) {
    return this._http.put(environment.url + "/actionTypes/forms/updateOrder", requestData, { headers: { "hideLoader": "true" }});
  }

  exportPDF(requestData) {
    return this._http.post(environment.url + "/download/pdf/" + requestData.orgId + "/" + requestData.actionType, requestData, {observe: 'response', responseType: 'blob'});
  }

  exportExcel(requestData) {
    return this._http.post(environment.url + "/download/excel/" + requestData.orgId + "/" + requestData.actionType, requestData, {observe: 'response', responseType: 'blob'});
  }

  refreshFormsList(forms) { 
    this.invokeEvent.next(forms);
  }

  getFormFilters(organizationId, isHelpAdmin?) {
    let endpoint = ""
    if(isHelpAdmin) {
      endpoint = `${environment.url}/forms/filters/${organizationId}?isHelpAdmin=true`
    } else {
      endpoint = `${environment.url}/forms/filters/${organizationId}`
    }
    return this._http.get(endpoint)
  }

  sendResetSelectedFormsEvent() {
    this.subject.next();
  }
  recieveResetSelectedFormsEvent() {
    return this.subject.asObservable();
  }
}
